import { createFileRoute } from "@tanstack/react-router";
import RegisterPage from "./register.$cspSlug";

export const Route = createFileRoute("/(auth)/register/")({
    component: () => <RegisterPage />,
});
